import { KEEP_SESSION_KEY, refreshToken } from './cognito';

export const errors = Object.freeze({
  expiredToken: 'The security token included in the request is expired',
  noToken: 'No token.',
  noAccess: 'User does not have portal access.',
  deactivated: 'User is deactivated.',
  noExist: 'User does not exist.',
});

const denied: string[] = [errors.deactivated, errors.noAccess, errors.noExist];

export const customFetchBuilder =
  ({
    onUnauthorized,
    onAccessDenied,
  }: {
    onUnauthorized: (response: Response) => Promise<never>;
    onAccessDenied: (response: Response) => Promise<never>;
  }) =>
  async (uri: URL | RequestInfo, options?: RequestInit) => {
    const response = await fetch(uri, options);

    if (response.status >= 500) return Promise.reject(new Error(response.status.toString()));

    if (response.status === 401) {
      const textError = await response.text();
      const keepSession = sessionStorage.getItem(KEEP_SESSION_KEY) === 'true';

      if (keepSession && textError === errors.noToken) {
        const newToken = await refreshToken();
        if (!newToken) return onUnauthorized(response);

        const newResponse = await fetch(uri, options);

        if (newResponse.status >= 500) return Promise.reject(new Error(newResponse.status.toString()));
        if (newResponse.status === 401) return onUnauthorized(newResponse);
        if (newResponse.status === 200) return newResponse;
      }

      if (denied.includes(textError)) return onAccessDenied(response);

      return onUnauthorized(response);
    }

    return response;
  };

export type TGlobalError =
  | 'network'
  | 'unauthorized'
  | 'not_found'
  | 'forbidden'
  | 'denied'
  | 'permission_denied'
  | null;
